export const OfferManagementStepperStatus = {
  Draft: 'Draft',
  InProgress: 'In Progress',
  OfferSubmitted: 'Offer Submitted',
  OfferReceived: 'Offer Received',
  OfferViewed: 'Offer Viewed',
  UnderNegotiation: 'Negotiation',
  OfferAccepted: 'Offer Accepted',
  OfferRejected: 'Offer Rejected',
  OfferRescinded: 'Offer Rescinded',
  Sold: 'Sold',
  ConditionsSatisfied: 'Conditions Satisfied',
  ConditionsNotSatisfied: 'Conditions Not Satisfied',
  PossessionDay: 'Possession Day',
  Expired: 'Expired',
};

export default {
  OfferManagementStepperStatus,
};
